import { Injectable } from '@angular/core';
import { WindowService } from '../window/window.service';
import { HelpWindowComponent } from './help-window/help-window.component';
import { TopicService } from './topic.service';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(
    private topicService: TopicService,
    private windowService: WindowService
  ) { }

  open(topicId: string) {
    this.topicService.setTopic(topicId);

    if (!this.windowService.isOpened(WINDOW_ID)) {
      this.windowService.open({
        title: $localize`Help`,
        componentType: HelpWindowComponent,
        position: {
          top: 8,
          left: 8
        },
        config: {
          id: WINDOW_ID
        }
      });
    }

  }
}

const WINDOW_ID = 'HELP_WINDOW';
